


































































































































import { CreateElement, VNode } from 'vue';
import { Component, Prop, Inject } from 'vue-property-decorator';
import { SwExtendedVue } from '../sw-extended-vue';
import { SwIcon } from '../sw-icon';
import { ProvidedTabParam, TabRenderFunction } from './types';

@Component({
  components: {
    SwIcon,
  },
})
export default class SwTab extends SwExtendedVue {
  @Prop({ type: String, required: true })
  tabId: string;

  @Prop(String)
  label: string;

  @Prop(String)
  icon: string;

  @Prop({ type: Boolean, default: false })
  disabled: boolean;

  @Prop({ type: Boolean, default: false })
  closable: boolean;

  @Prop({ type: Function })
  innerRender: TabRenderFunction;

  @Prop({ type: Boolean, default: false })
  active: boolean;

  @Inject()
  tabParam: ProvidedTabParam;

  @Inject()
  claimTabSelected: any;

  @Inject()
  claimTabClose: any;

  get effectiveIcon() {
    if (!this.icon) { return null; }
    const iconObj = { name: this.icon };
    return iconObj;
  }

  get isCustomizedRendering(): boolean {
    return !!this.innerRender && typeof this.innerRender === 'function';
  }

  onClickTab(event: MouseEvent) {
    event.preventDefault();
    if (this.disabled) { return; }
    this.claimTabSelected(this.tabId);
  }

  onClickClose(event: MouseEvent) {
    event.stopPropagation();
    event.preventDefault();
    if (this.disabled) { return; }
    this.claimTabClose(this.tabId);
  }

  /* tslint:disable-next-line */
  render(h: CreateElement): VNode {
    const tabNodes: VNode[] = [];

    if (this.isCustomizedRendering) {
      tabNodes.push(this.innerRender(h, {
        props: {
          tabId: this.tabId,
          label: this.label,
          icon: this.icon,
          disabled: this.disabled,
          closable: this.closable,
        },
        active: this.active,
      }));
    } else {
      if (!!this.effectiveIcon) {
        tabNodes.push(
          <span class={['sw-tab__inner__piece']}>
            <sw-icon name={this.effectiveIcon.name} size="small" as-block></sw-icon>
          </span> as VNode,
        );
      }
      if (this.label) {
        tabNodes.push(
          <span class={['sw-tab__inner__piece', 'sw-flexbox__flex', 'sw-flexbox', 'sw-flexbox--center-justify']}>
            <span>{ this.label }</span>
          </span> as VNode,
        );
      }
      if (this.closable) {
        tabNodes.push(
          <span class={['sw-tab__inner__piece']}>
            <sw-icon class="sw-tab__inner__piece__close-mark"
              name="close"
              size="xsmall"
              as-block
              nativeOnClick={this.onClickClose}
            ></sw-icon>
          </span> as VNode,
        );
      }
    }

    const rootNode = (
      <li class={['sw-tab', `sw-tab--${this.tabParam.theme}`, `sw-tab--l${this.tabParam.level}`, 'sw-flexbox',
        {
          'sw-tab--disabled': this.disabled,
          'sw-tab--active': this.active,
          'sw-tab--vertical': this.tabParam.vertical,
          'sw-tab--customized': this.isCustomizedRendering,
        }]}
        onClick={this.onClickTab}
      >
        <div class={['sw-tab__inner', 'sw-flexbox', 'sw-flexbox--center-items']}>
          {tabNodes}
        </div>
      </li>
    );

    return rootNode as VNode;
  }
}
